import PropTypes from 'prop-types';
import TitledTextField from '../../core/TitledTextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import CancelButton from '../CancelButton';
import CreateButton from '../CreateButton';
import PrimaryButton from '../PrimaryButton';
import { globalStyles as styles } from '../style/gstheme';
import { MAX_USERNAME_LENGTH } from '../utils/constants';
import { fullySanitiseText } from '../utils/utils';
import { makeCancelable } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';

class InviteUserDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            username: "",
            isDuplicate: false,
            invalid: false
        };
        this.cancellable = null;
    }

    handleChange = (event) => {
        const t = event.target;
        const cleanText = fullySanitiseText(t.value);
        const { invitedUsers, existingUsers } = this.props;
        const invalid = invitedUsers.includes(cleanText) || existingUsers.some(user => user.username === cleanText);
        this.setState({ [t.name]: cleanText, invalid, isDuplicate: invalid });
    };

    handleClickOpen = () => { this.setState({ open: true }); };

    inviteUser = async () => {
        const exists = await this.doUsernameCheck().promise;
        if (this.cancellable && !this.cancellable.isCancelled()) {
            if (exists) {
                this.props.onInviteUser(this.state.username);
                this.exitInviteUser();
            }
            else {
                this.setState({ invalid: true });
            }
        }
    };

    doUsernameCheck() {
        this.cancellable = makeCancelable(
            GS.doesUsernameExist(this.state.username)
        );
        return this.cancellable;
    }

    exitInviteUser = () => this.setState({
        open: false,
        username: "",
        invalid: false
    });

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    render() {

        const { classes, withdrawnUsernames, invitedUsers } = this.props;
        const { username, invalid, isDuplicate } = this.state;

        return (
            <React.Fragment>
                <CreateButton onClick={this.handleClickOpen} label="Invite User" />
                <Dialog
                    data-test="invite-user"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.smallDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    aria-labelledby="createuser-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="createbuser-dialog-title">Invite User</DialogTitle>
                    <DialogContent style={{ height: 120 }}>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="username"
                                name="username"
                                title="Username"
                                autoFocus
                                placeholder="Enter username to invite (case sensitive)"
                                required={true}
                                text={username}
                                helperText={isDuplicate ?
                                    (withdrawnUsernames.includes(username) ?
                                        "User has just been removed."
                                        :
                                        (invitedUsers.includes(username) ?
                                            "User has been recently invited."
                                            :
                                            "User is already invited."
                                        )
                                    )
                                    :
                                    (invalid ?
                                        "Username does not exist."
                                        :
                                        ""
                                    )}
                                maxLength={MAX_USERNAME_LENGTH}
                                onChange={this.handleChange} />
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitInviteUser} />
                        <PrimaryButton disabled={invalid || username === ""} onClick={this.inviteUser}>Invite</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

InviteUserDialog.propTypes = {
    classes: PropTypes.object,
    existingUsers: PropTypes.array.isRequired,
    invitedUsers: PropTypes.array.isRequired,
    withdrawnUsernames: PropTypes.array.isRequired,
    onInviteUser: PropTypes.func.isRequired
};

export default withStyles(styles)(InviteUserDialog);